module.exports = __webpack_public_path__ + "static/media/trimex_extrafina_victoria.f6080299.png";